import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class ClearFiltersCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.CLEAR_FILTERS;

    public tags = ['ui', 'filters', 'clear'];

    constructor() {
        super('filters', 'system', undefined);
    }
}